import { datadogRum } from '@datadog/browser-rum';

import { appendAdTechWallpaper } from '@wetransfer/ad-sdk';

import { DD_AD_SDK_MANIFEST_LOADED } from '@wetransfer/transfer/constant/datadog';
import scriptLoader from '@wetransfer/transfer/helper/script-loader';
import ErrorHandler from '@wetransfer/transfer/modules/error-handler';

import { WALLPAPER_ERROR_MESSAGES } from './constants';
import {
  createLocalUrl,
  getHost,
  getManifestEntryPoint,
  emitWallpaperLoaded,
  getEnv,
} from './helpers';

/**
 * Docs: app/javascript/wallpaper-bundle/README.md
 */
export const load = async (): Promise<void> => {
  const host = getHost();
  const MANIFEST_FILE_NAME = 'asset-manifest.json';

  const manifestUrl = `${host}/${MANIFEST_FILE_NAME}`;
  let entryPointUrl;

  try {
    const entryPoint = await getManifestEntryPoint(manifestUrl);
    entryPointUrl = `${host}/${entryPoint}`;

    //loading the script from the same host enables clear error messages
    const { localUrl, cleanup: cleanLocalUrl } = await createLocalUrl(
      entryPointUrl
    );

    await scriptLoader(localUrl, {
      async: true,
      crossOrigin: 'anonymous',
    });

    datadogRum.addTiming(DD_AD_SDK_MANIFEST_LOADED);

    cleanLocalUrl();

    emitWallpaperLoaded();
  } catch (error) {
    ErrorHandler.track(new Error(WALLPAPER_ERROR_MESSAGES.LOAD_FAILED), {
      errorMessage: error.message,
      manifestUrl,
      entryPointUrl,
      ...(error.response && {
        errorResponse: {
          data: error.response.data,
          status: error.response.status,
          headers: error.response.headers,
        },
      }),
      ...(error.request && {
        errorRequest: {
          readyState: error.request.readyState,
          timeout: error.request.timeout,
        },
      }),
    });

    appendAdTechWallpaper({
      environment: getEnv(),
    });

    emitWallpaperLoaded();
  }
};
